
// Added by Divya
export const globalEthnicityList = [
  { name: "Select Ethnicity", value: "" },

  // White
  { name: "White", value: "", isGroup: true },
  { name: "   English, Welsh, Scottish, Northern Irish or British", value: "english_welsh_scottish_northern_irish_british" },
  { name: "   Irish", value: "irish" },
  { name: "   Gypsy or Irish Traveller", value: "gypsy_or_irish_traveller" },
  { name: "   Roma", value: "roma" },
  { name: "   Any other White background", value: "other_white_background" },

  // Mixed
  { name: "Mixed or multiple ethnic groups", value: "", isGroup: true },
  { name: "   White and Black Caribbean", value: "white_black_caribbean" },
  { name: "   White and Black African", value: "white_black_african" },
  { name: "   White and Asian", value: "white_asian" },
  { name: "   Any other Mixed or multiple ethnic background", value: "other_mixed_background" },

  // Asian
  { name: "Asian or Asian British", value: "", isGroup: true },
  { name: "   Indian", value: "indian" },
  { name: "   Pakistani", value: "pakistani" },
  { name: "   Bangladeshi", value: "bangladeshi" },
  { name: "   Chinese", value: "chinese" },
  { name: "   Any other Asian background", value: "other_asian_background" },

  // Black
  { name: "Black, Black British, Caribbean or African", value: "", isGroup: true },
  { name: "   Caribbean", value: "caribbean" },
  { name: "   African", value: "african" },
  { name: "   Any other Black, Black British, Caribbean or African background", value: "other_black_background" },

  // Other
  { name: "Other ethnic group", value: "", isGroup: true },
  { name: "   Arab", value: "arab" },
  { name: "   Any other ethnic group", value: "other_ethnic_group" },

  // Disclosure
  { name: "Disclosure option", value: "", isGroup: true },
  { name: "   Prefer not to say", value: "prefer_not_to_say" },
];